import(/* webpackMode: "eager" */ "/home/runner/_work/px-painel/px-painel/app/(public)/terms-of-use/page.tsx");
